export enum Section {
    CalculatorForm,
    Breakdown,
    BankComparison,
    YearlyBudget
}

export enum CardType {
    Visa = 'visa',
    Mastercard = 'mastercard',
}

export interface ICurrency {
    'symbol': string;
    'name': string;
    'symbol_native': string;
    'decimal_digits': number;
    'rounding': number;
    'code': string;
    'name_plural': string;
}

export interface ICurrencyMap {
    [code: string]: ICurrency;
}

export enum Providers {
    Visa = 'visa',
    Mastercard = 'mastercard',
}

export enum CardBank {
    YourBank = 'Your bank',
    Payhawk = 'Payhawk',
    Spendesk = 'Spendesk',
}

export interface IFeeComparison {
    type: CardBank;
    amount: number;
}